module.exports = __webpack_public_path__ + "static/media/straight.f67846ee.svg";